module.exports = __webpack_public_path__ + "media/assets/DoubleArrow-58faebb664e03f7f1a5861bdbf997084.svg";